import {QUOTE_ITEM, CHECKOUT} from 'constants/actions';

import {CartSectionType, HtoCartType} from './cartType';
import {createReducer} from 'redux-act';
import {AxiosResponse} from 'axios';

/**
 * Get HTO info for cart
 */
export default createReducer<HtoCartType>({}, null)
    .on(
        `${QUOTE_ITEM.GET_ITEMS}_FULFILLED`,
        (
            _: HtoCartType,
            payload: AxiosResponse<{
                hto: {enableMode: boolean; sectionType: CartSectionType};
            }>,
        ): HtoCartType =>
            payload.data.hto
                ? {
                      selected: payload.data.hto.enableMode,
                      mode: payload.data.hto.sectionType,
                      status: 'fulfilled',
                      isAttentionAccented: false,
                  }
                : null,
    )
    .on(
        `${CHECKOUT.GET_ORDER_REVIEW_ITEMS}_FULFILLED`,
        (
            state: HtoCartType,
            payload: AxiosResponse<{active: boolean; productAsHTO: boolean}[]>,
        ): HtoCartType =>
            state === null
                ? state
                : {
                      ...state,
                      selected: payload.data
                          .filter(item => item.active)
                          .every(item => item.productAsHTO),
                      status: 'fulfilled',
                  },
    );
